import loader from '@src/LottieAnimations/loader.json';
import React, { FC } from 'react';
import { LottieLite } from '@src/LottieAnimations/LottieLite';

type LoaderComponentProps = {
  dataTestId?: string;
};

export const LoaderComponent: FC<LoaderComponentProps> = ({ dataTestId }) => {
  /*TODO move all these files into css// IMPORTANT*/
  const containerStyle: React.CSSProperties = {
    fontFamily: 'Plus Jakarta Sans',
    textAlign: 'center',
    backgroundColor: '#57568e',
    padding: '40px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    flexDirection: 'column',
  };

  return (
    <div data-test-id={dataTestId} style={containerStyle}>
      <LottieLite animationData={loader} style={{ width: 250 }} />
    </div>
  );
};
